import { useMutation } from "@tanstack/react-query";

import { admireUser, AdmireUserRequest } from "@/api";


const useAdmireUser = () => {
  return useMutation({
    mutationFn: ({ userId }: AdmireUserRequest) => {
      return admireUser({ userId });
    },
  });
};

export { useAdmireUser };
